module.exports = __webpack_public_path__ + "static/media/stats-2008.73f2ac75.png";